import { SystemActions, selectInstitution, selectBetaAccesses, } from '../../../store/features/system';
import { API } from '../../../vendor/api';
import { setWorkflow } from '../actions/index';
import { initLauncher } from '../initialiser';
import * as types from '../constants/action-types';
const dokbotCustomSurvey = (store) => (next) => (action) => {
    const { getState, dispatch } = store;
    if (action.type === SystemActions.SET_ROOM) {
        const institution = selectInstitution(getState());
        const institutionId = institution ? institution.id : null;
        if (institutionId) {
            API.dokbotWorkflow
                .getWorkflow({ institutionId })
                .then((workflow) => {
                const { providerSurveyId, isDokbotExtensionInstalled } = workflow;
                const isDokbotAvailable = isDokbotExtensionInstalled &&
                    selectBetaAccesses(getState())['extension:dokbot'];
                dispatch(setWorkflow({
                    ...workflow,
                    isDokbotExtensionInstalled: isDokbotAvailable,
                }));
                next(action);
                initLauncher(providerSurveyId, isDokbotAvailable);
            })
                .catch(() => {
                next(action);
            });
        }
    }
    if (action.type === types.INIT_DOKBOT) {
        const { institutionId, userId } = action.payload;
        const params = institutionId ? { institutionId } : { userId };
        API.dokbotWorkflow
            .getWorkflow(params)
            .then((workflow) => {
            const { patientSurveyId, isDokbotExtensionInstalled } = workflow;
            dispatch(setWorkflow(workflow));
            next(action);
            initLauncher(patientSurveyId, isDokbotExtensionInstalled);
        })
            .catch(() => {
            next(action);
        });
    }
    next(action);
};
export default dokbotCustomSurvey;
